<script setup lang="ts">
defineOptions({
	name: 'ControllerSection',
})

const { t: $t, locale } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:baseline-sync"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Controller') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'The Controller of the Personal Data collected through the Platform is Gaveta Decimal. For questions relating to privacy and data protection, Users may contact Gaveta Decimal through the following e-mail address',
					)
				}}{{ locale === 'fr' ? ' :' : ':' }} hello@lucky-wise.com
			</p>
		</div>
	</section>
</template>
